<script setup lang="ts">
import { myRequest } from '@/utils/fetch'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const text = ref('')
const submitting = ref(false)
const show = ref(true)
const router = useRouter()

const submit = async () => {
  submitting.value = true
  await myRequest('POST', '/app/howDidYouHear', { text: text.value })
  router.push('/onboarding/calendars')
  submitting.value = false
}

onMounted(() => {
  // Check for affiliate name in localStorage
  const affiliateName = localStorage.getItem('affiliate_name')
  if (affiliateName && affiliateName !== '') {
    text.value = `Referred by ${affiliateName}`
  }
})
</script>

<template>
  <q-dialog v-model="show" persistent>
    <div class="myCard q-pa-md">
      <h5 class="q-mb-md">Welcome to MeetingHero.AI</h5>

      <div class="text">How did you hear about us?</div>
      <q-input placeholder="e.g. Google, Specific Friend, Social Media..." v-model="text" rounded /><br />
      <q-btn @click="submit" class="full-width" color="secondary" :loading="submitting" :disable="submitting"
        >Submit</q-btn
      >
    </div>
  </q-dialog>
</template>
